import { Card, CardBody, Col } from "reactstrap";
import MinMaxValueForm from "./MinMaxValueForm";
import { BasicSliderData } from "../../../../data/bonusUi/RangSlider";
import { MinMaxValues } from "../../../../constants";
import CommonCardHeader from "../../../../coreComponents/CommonCardHeader";

const MinMaxValue = () => {
  return (
    <Col lg="6">
      <Card>
        <CommonCardHeader title={MinMaxValues} span={BasicSliderData} />
        <CardBody>
          <MinMaxValueForm />
        </CardBody>
      </Card>
    </Col>
  );
};

export default MinMaxValue;
